import { render, staticRenderFns } from "./OurEmptyTabMessage.vue?vue&type=template&id=157a38b3&"
import script from "./OurEmptyTabMessage.vue?vue&type=script&lang=js&"
export * from "./OurEmptyTabMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports